import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { HomeModule } from './modules/home/home.module';
import { LoginModule } from './modules/login/login.module';
import { AuthenticationGuard } from './guards/authentication.guard';
import { ImportAndExportDataModule } from './modules/user/importAndExportData.module';
import { MailingPageModule } from './modules/mailing-list/mailing-page.module'
import { InfoModule } from './modules/help/components/info.module';
import { OtherKpPageModule } from './modules/other-kp/other-kp-page.module';

const routes: Routes = [
    {
        path: 'login',
        loadChildren: () => LoginModule
    },
    {
        path: 'home',
        canActivate: [AuthenticationGuard],
        loadChildren: () => HomeModule
    },{
        path: 'home/:id',
        canActivate: [AuthenticationGuard],
        loadChildren: () => HomeModule
    },
    {
        path: 'data',
        canActivate: [AuthenticationGuard],
        loadChildren: () => ImportAndExportDataModule 
    },
    {
        path: 'mailing',
        canActivate: [AuthenticationGuard],
        loadChildren: () => MailingPageModule
    },
    {
        path: 'other-kp',
        canActivate: [AuthenticationGuard],
        loadChildren: () => OtherKpPageModule
    },
    {
        path: 'help',
        canActivate: [AuthenticationGuard],
        loadChildren: () => InfoModule
    },
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: ''
    },
    
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
    constructor(private router: Router) {
        this.router.errorHandler = (error: any) => {
            console.log("error",error);
            this.router.navigate(['/home']);
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts